// extracted by mini-css-extract-plugin
module.exports = {"text":"FillInTheBlanks_text__2DIDN","notYetSelected":"FillInTheBlanks_notYetSelected__V4P4Y","optionsToSelect":"FillInTheBlanks_optionsToSelect__1iUko"};